import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/gossip";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-600 font-medium">
              <i className="ri-question-line" />
              常见问题
            </span>
            <h2 className="mt-2.5 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              关于看料专区的几个问题
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              第一次来不知道从哪里看起？先看看下面这些常被问到的问题，基本能覆盖入口分类、更新频率和内容原则。
            </p>
            <div className="mt-6 p-5 rounded-lg bg-secondary-100 border border-secondary-200">
              <p className="text-sm text-foreground-700 leading-relaxed">
                还有别的问题？可以到
                <Link to="/contact" className="mx-1 text-primary-600 font-medium hover:text-primary-700 cursor-pointer">联系我们</Link>
                页面留言，编辑会逐条查看。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = open === index;
                return (
                  <div
                    key={item.q}
                    className={`rounded-lg border transition-colors ${
                      isOpen ? "bg-background-50 border-primary-300" : "bg-background-50 border-background-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 -mt-1">
                        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}